import { Button } from "@/ui-components/ui/button";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ProductsFetcher } from "./fetcher";

const ProductsSettings = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [reload, setReload] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Produkte</PageTitle>
          <Link to={`/settings/products/create`}>
            <Button className="px-4 py-2 bg-blue-500 text-white rounded-md">+ Neues Produkt</Button>
          </Link>
        </div>
      </PageTitleContainer>
      <ProductsFetcher searchQuery={searchQuery} setReload={setReload} reload={reload} />
    </div>
  );
};

export default ProductsSettings;
